import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { VendorPacketEventViewModel } from '@models/Vendor';
import ReactTable, { Column } from 'react-table';
import { dateParser } from '@common/dateParser';
import { OptionsViewModel } from '@models/common.models';
import { SpinnerPage, ModalProps } from '@common/components';
import { VendorPacketEditComponent } from 'src/vendor/_components/vendor-packet/vendor-packet-edit.component';

export interface VendorPacketEventsComponentProperties extends RouteComponentProps<{ id: number }> {
  readonly vendorId: number;
  readonly packetEvents: Array<VendorPacketEventViewModel>;
  readonly getVendorPacketEvents: (vendorId: number) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly saveVendorPacketEvent: (vendorPacketEvent: VendorPacketEventViewModel) => void;
}

export class VendorPacketEventsComponent extends React.Component<VendorPacketEventsComponentProperties> {
  componentWillMount() {
    this.props.getVendorPacketEvents(this.props.vendorId);
  }

  openEditModal = (vendorPacketEvent: VendorPacketEventViewModel) => {
    this.props.toggleModal({
      childProps: {
        vendorPacketEvent: vendorPacketEvent,
        submitForm: this.props.saveVendorPacketEvent
      },
      closeLabel: 'Cancel',
      component: VendorPacketEditComponent,
      saveCallback: this.props.toggleModal,
      saveLabel: 'Save',
      title: 'Edit Vendor Packet Event'
    });
  };

  render() {
    if (!this.props.packetEvents) {
      return <SpinnerPage />;
    }
    const columns: Column[] = [
      {
        accessor: (vm: VendorPacketEventViewModel) =>
          vm ? (
            <a className="active" onClick={() => this.openEditModal(vm)}>
              {vm.packetEventName}
            </a>
          ) : (
            '--'
          ),
        id: 'link',
        Header: 'Description',
        sortable: true
      },
      {
        accessor: 'packetEventDate',
        Header: 'Date',
        sortable: true,
        Cell: (props: { value?: string }) => (
          <>{props.value ? dateParser.parse(dateParser.parseDateToLocalTime(props.value)).format('l LT') : '--'}</>
        )
      },
      {
        accessor: 'packetEventEmployee',
        Header: 'Logged by',
        sortable: true,
        Cell: (props: { value?: OptionsViewModel }) => <>{props.value ? props.value.value : '--'}</>
      }
    ];
    return (
      <>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          defaultPageSize={10}
          manual={true}
          data={this.props.packetEvents}
        />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-packet/vendor-packet-events.component.tsx